import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h2>J&C Renovations</h2>
            <p>Your trusted general contractor</p>
          </div>
          
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <address>
              <p>Waddy, Kentucky</p>
              <p>Phone: (502) 220-7640</p>
              <p>Email: info@jandcrenovations.com</p>
            </address>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#service-area">Service Area</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-credentials">
            <h3>Credentials</h3>
            <ul>
              <li>Licensed General Contractor</li>
              <li>Fully Insured</li>
              <li>A+ BBB Rating</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} J&C Renovations LLC. All rights reserved.</p>
          <div className="footer-social">
            {/* Social media icons can be added here */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
